import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from "yup";
import { Link, useNavigate } from 'react-router-dom'
import { FcGoogle } from "react-icons/fc";
import hoastLogo from "../../../assets/images/HOAST-LOGO_2 1.png"
import { LuEye, LuEyeClosed } from "react-icons/lu";
import { useEffect, useState } from 'react';
import EllipsisLoader from '../../../base_component/EllipsisLoader/EllipsisLoader';
import { X } from 'lucide-react';
import Dialog from '../../../base_component/Dialog/Dialog';
import docimg from "../../../assets/images/image.png";
import { v4 as uuidv4 } from "uuid";
import toast from 'react-hot-toast';
import { loginApi, loginThirdPartyAPI } from '../../../service/ApiServices';
import { auth, googleprovider, messaging } from "../../../firebase/Firebase";
import { getToken } from "firebase/messaging";
import { signInWithPopup } from 'firebase/auth';

export default function Login() {
    const navigate = useNavigate()
    const [showPassword, setShowPassword] = useState(false);
    const [googleauthModal, setGoogleauthModal] = useState(false);
    const [isTermsAccepted, setIsTermsAccepted] = useState(false);
    const [fcmToken, setFcmToken] = useState("");
    const [isPermissionModalOpen, setIsPermissionModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    let deviceId = localStorage.getItem("deviceIdHoast");

    useEffect(() => {
        if (!deviceId) {
            deviceId = uuidv4();
            localStorage.setItem("deviceIdHoast", deviceId);
        }
    }, [deviceId]);

    const initialValues = {
        email: "",
        password: "",
    };

    const validationSchema = Yup.object({
        email: Yup.string().email("Invalid email").required("Email Required"),
        password: Yup.string().min(8, "Minimum 8 characters").matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/, "Must include uppercase, lowercase, and a number").required("Password Required"),
    });

    const requestPermissionAndGetToken = async () => {
        try {
            const notificationsSupported = typeof window !== 'undefined' && 'Notification' in window;
            const swSupported = typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
            if (!notificationsSupported || !swSupported) {
                console.warn("Notifications or Service Worker not supported in this browser.");
                setFcmToken("");
                return null;
            }

            const permission = await Notification.requestPermission();
            if (permission !== "granted") {
                console.log("Notification permission not granted (", permission, ")");
                setFcmToken("");
                setIsPermissionModalOpen(true);
                return null;
            }

            let registration = await navigator.serviceWorker.getRegistration();
            if (!registration) {
                try {
                    registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
                } catch (swError) {
                    console.error("Failed to register service worker for FCM:", swError);
                    setFcmToken("");
                    return null;
                }
            }

            if (!messaging) {
                console.warn("Firebase messaging is not initialized.");
                setFcmToken("");
                return null;
            }

            const token = await getToken(messaging, {
                vapidKey: "BFwykkxeXec33S2lR4zP_47ysqpwbzNgqkZw7aUYJq2-vFwfhsK1hN-2sAIwCru4JKtQZ1HgXaVFPALv1WCBCg8",
                serviceWorkerRegistration: registration,
            });
            console.log("FCM Token:", token);
            setFcmToken(token || "");
            return token;
        } catch (error) {
            console.error("Error getting FCM token:", error);
            setFcmToken("");
            return null;
        }
    };

    useEffect(() => {
        requestPermissionAndGetToken();
    }, []);

    const onSubmit = async (values) => {
        setIsLoading(true);

        let params = {
            email: values.email,
            password: values.password,
            device_id: deviceId,
            device_token: fcmToken || "abcd1234",
            device_type: "web",
        };
        loginApi(params)
            .then((res) => {
                const message = res?.data?.message;
                const token = res?.data?.access_token;
                const status = res?.data?.status;

                if (status === 1) {
                    setIsLoading(false);
                    localStorage.setItem("hoast_user_id", res?.data?.data?.id);
                    localStorage.setItem("is_free_plan_days", res?.data?.data?.free_tier_days);
                    if (res?.data?.data?.is_account_created === true) {
                        navigate("/profile");
                        localStorage.setItem("hoast_token", token);
                        localStorage.setItem("hoast_refresh_token", res?.data?.refresh_token);
                        toast.success(message);
                    } else {
                        if (res?.data?.data?.is_plan_active === true) {
                            navigate("/account_setup");
                        } else {
                            navigate("/subscription", { state: { token: token } });
                        }
                    }
                    if (res?.data?.data?.is_plan_active === true) {
                        localStorage.setItem("plan", "yes");
                    } else {
                        localStorage.setItem("plan", "no");
                    }
                } else {
                    setIsLoading(false);
                    toast.error(message);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                const message = err?.response?.data?.message;
                toast.error(message);
            });
    };

    const handleGoogleAuth = async (e) => {
        e.preventDefault();
        try {
            const result = await signInWithPopup(auth, googleprovider);

            const thirdPartyEmail = result?.user?.email;
            const thirdPartyId = result?.user?.uid;
            const displayName = result?.user?.displayName || "";
            const nameParts = displayName.trim().split(" ");
            const firstName = nameParts[0] || "";
            const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";

            signIn(thirdPartyEmail, thirdPartyId, firstName, lastName);
        } catch (error) {
            console.error("Error during sign-in:", error.message);
        }
    };

    const signIn = (ThirdpartyEmail, ThirdpartyId, firstName, lastName) => {
        let param = {
            email: ThirdpartyEmail,
            third_party_id: ThirdpartyId,
            first_name: firstName,
            last_name: lastName,
            device_type: "web",
            role: "artist",
            login_type: "Google",
            device_id: deviceId ? deviceId : "abc",
            device_token: fcmToken ? fcmToken : "123",
        };

        loginThirdPartyAPI(param)
            .then((response) => {
                setGoogleauthModal(false);
                if (response.data.status === 1) {
                    localStorage.setItem("hoast_user_id", response?.data?.data?.id);
                    localStorage.setItem("is_free_plan_days", response?.data?.data?.free_tier_days);
                    if (response?.data?.data?.is_account_created === true) {
                        navigate("/profile");
                        localStorage.setItem("hoast_token", response?.data?.access_token);
                        localStorage.setItem("hoast_refresh_token", response?.data?.refresh_token);
                        toast.success(response?.data?.message);
                        if (response?.data?.data?.is_plan_active === true) {
                            localStorage.setItem("plan", "yes");
                        } else {
                            localStorage.setItem("plan", "no");
                        }
                    } else {
                        if (response?.data?.data?.is_plan_active === true) {
                            navigate("/account_setup");
                        } else {
                            navigate("/subscription", { state: { token: response?.data?.access_token } });
                        }
                    }
                } else {
                    toast.error(response?.data?.message);
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error(error?.response?.data?.message);
            });
    };

    return (
        <div className="h-screen flex flex-col items-center justify-center px-4">
            <div className="flex justify-center mb-4">
                <img src={hoastLogo} alt="Logo" className="md:h-36 h-24" />
            </div>
            <div className="bg-white md:p-8 p-5 rounded-xl shadow-md w-full max-w-xl">
                <h2 className="md:text-2xl text-xl font-semibold text-start mb-1">Welcome back!</h2>
                <p className="text-start text-sm text-gray-500 mb-6">Please log in to continue.</p>

                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                    {({ values, isValid }) => (
                        <Form className="space-y-4">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-[#667085]">
                                    Email
                                </label>
                                <Field
                                    type="email"
                                    name="email"
                                    placeholder="Enter email"
                                    className="mt-1 block text-sn w-full px-4 py-3 border-2 border-gray-300 rounded-xl shadow-sm focus:border-2 focus:outline-none focus:border-[#24B565]"
                                />
                                <ErrorMessage name="email" component="div" className="text-red-500 text-xs mt-1" />
                            </div>

                            <div className="relative">
                                <label htmlFor="password" className="block text-sm font-medium text-[#667085]">
                                    Password
                                </label>
                                <Field
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Enter password"
                                    className="mt-1 block text-sn w-full px-4 py-3 border-2 border-gray-300 rounded-xl shadow-sm focus:border-2 focus:outline-none focus:border-[#24B565]"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-4 top-10 text-gray-500"
                                    tabIndex={-1}
                                >
                                    {showPassword ? <LuEye size={20} /> : <LuEyeClosed size={20} />}
                                </button>
                                <ErrorMessage name="password" component="div" className="text-red-500 text-xs mt-1" />
                            </div>

                            <div className="text-start text-sm">
                                <Link to={"/forgot_password"} className="text-[#667085]">
                                    Forgot your password?
                                </Link>
                            </div>

                            <button
                                type="submit"
                                disabled={isLoading}
                                className={`w-full h-[52px] rounded-xl transition duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed ${values.email && values.password
                                    ? 'bg-black text-white'
                                    : 'bg-[#F0F1F3] text-gray-500'
                                    }`}
                            >
                                {isLoading ? (
                                    <EllipsisLoader color={values.email && values.password ? "white" : "red"} />
                                ) : (
                                    'Continue'
                                )}
                            </button>

                            <p className="text-sm text-center text-gray-500">
                                Don't have an account?{" "}
                                <Link to={"/create_account"} href="#" className="text-[#F48B94]">
                                    Sign up
                                </Link>
                            </p>

                            <div className="flex items-center my-4">
                                <div className="flex-grow border-t border-gray-300"></div>
                                <span className="mx-2 text-sm text-gray-400">or</span>
                                <div className="flex-grow border-t border-gray-300"></div>
                            </div>

                            <button
                                type="button"
                                className="w-full border border-gray-300 flex items-center justify-center gap-2 py-3 rounded-xl text-sm hover:bg-gray-100"
                                onClick={() => setGoogleauthModal(true)}
                            >
                                <FcGoogle className="text-xl" />
                                Continue with Google
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>

            <Dialog
                open={googleauthModal}
                onClose={() => setGoogleauthModal(false)}
                size="md"
            >
                <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

                <Dialog.Panel>
                    <div className='flex justify-center relative mt-5'>
                        <h1 className="md:text-2xl text-lg font-semibold text-black">
                            Terms & Conditions
                        </h1>
                        <button
                            className="bg-[#F4F5FA] text-sm rounded-xl absolute right-0 top-0 sm:mx-3 mx-2"
                            onClick={() => setGoogleauthModal(false)}
                        >
                            <X className='w-6 h-6' />
                        </button>
                    </div>

                    <Dialog.Description>
                        <div className="flex justify-center text-start md:px-8 px-3">
                            <div>
                                <div className='my-3'>
                                    <img src={docimg} className='md:w-[100px] w-[70px] md:h-[100px] h-[70px] mx-auto object-cover' alt="" />
                                </div>
                                <div className="flex items-start my-3">
                                    <div className="relative">
                                        <input
                                            type="checkbox"
                                            id="termsCheckbox"
                                            checked={isTermsAccepted}
                                            onChange={(e) => setIsTermsAccepted(e.target.checked)}
                                            className="mt-2 mr-2 w-5 h-5 rounded-md border-2 border-[#1f2a38a7] cursor-pointer appearance-none checked:bg-[#1f2a38] peer"
                                        />
                                        <svg
                                            className="absolute top-2 w-5 h-5 pointer-events-none hidden peer-checked:block"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M5 13l4 4L19 7"
                                                stroke="white"
                                                strokeWidth="2"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <p className="md:text-base text-sm text-gray-500 cursor-pointer">
                                        I need and agree to <Link to="/terms-conditions" className='text-black font-semibold hover:text-[#24B565] transition-colors'>Terms & Conditions</Link> and <Link to="/privacy-policy" className='text-black font-semibold hover:text-[#24B565] transition-colors'>Privacy Policy</Link>.
                                    </p>
                                </div>
                                <div className="flex items-center my-8 justify-center">
                                    <button
                                        onClick={handleGoogleAuth}
                                        disabled={!isTermsAccepted || isLoading}
                                        className="bg-[#1f2a38] h-[52px] w-full text-sm rounded-xl sm:mx-3 mx-2 text-white disabled:bg-[#F0F1F3] disabled:text-black disabled:cursor-not-allowed flex items-center justify-center"
                                    >
                                        {isLoading ? (
                                            <EllipsisLoader color="#1f2a38" />
                                        ) : (
                                            "Continue"
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Dialog.Description>
                </Dialog.Panel>
            </Dialog>
            {/* <Dialog open={isPermissionModalOpen} onClose={() => setIsPermissionModalOpen(false)} size="sm" staticBackdrop>
                <Dialog.Panel>
                    <Dialog.Title>
                        <div className="flex items-center justify-between w-full">
                            <h3 className="text-lg font-semibold text-slate-800">Enable Notifications</h3>
                        </div>
                    </Dialog.Title>
                    <Dialog.Description>
                        <div className="px-5 py-4 text-slate-700">
                            <p className="mb-3">
                                Notifications are currently disabled for this site.
                            </p>
                            <p className="text-sm text-slate-600">
                                To stay informed about important updates, please enable notifications
                                in your browser settings.
                                If you prefer, you can also continue without enabling notifications.
                            </p>
                        </div>
                    </Dialog.Description>
                    <Dialog.Footer>
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={handleContinueWithout}
                                className="h-[40px] px-4 rounded-xl text-white bg-[#1f2a38] shadow-md"
                            >
                                Continue without
                            </button>
                        </div>
                    </Dialog.Footer>
                </Dialog.Panel>
            </Dialog> */}
        </div>
    )
}
